import React from 'react';

export const PassBlock = ({ passList, isPilotRight, passengerCount, crewCount, reverseManifestSeatNumbers }) => {
  let seatsCount = 0;

  const generateRow = (row) => {
    const newRow = row.map((pass) => {
      let safePass = pass;

      if (pass === null) {
        safePass = {}
      }

      const { firstName, lastName, fullName, weight = 0, type } = safePass;

      if (type !== 'Pilot') {
        seatsCount = seatsCount + 1;
      }

      let safeFullName = 'Empty seat';

      if (firstName && lastName) {
        safeFullName = `${firstName} ${lastName}`;
      } else if (!firstName && !lastName && fullName) {
        safeFullName = fullName;
      }

      const seatTitle = type === 'Pilot' ? 'Pilot' : `Seat ${seatsCount}`;

      const pilotRightClass = type === 'Pilot' && isPilotRight
        ? 'pilot-right'
        : '';

      return (
        <div className={`pass-item ${pilotRightClass}`} key={safeFullName}>
            <span className='pass-item-data'>
              <span className='pass-item-data-name' children={seatTitle} />
              <span className='pass-item-data-weight' children={weight} />
            </span>
          <span className='pass-item-name' children={safeFullName} />
        </div>
      )})

    return reverseManifestSeatNumbers ? newRow.reverse() : newRow;
  }

  return (
    <div className='flex-column pass-block-wrapper'>
      <div className='top-indent pass-block'>
        {passList.map((row, index) =>
          <div className='pass-block-row' key={`row-${index}`} children={generateRow(row)} />
        )}
      </div>
      <span className='pass-block-total' children={`Total Passengers: ${passengerCount}, Total Crew: ${crewCount}`} />
    </div>
  );
};
